<template>
    <div>
        <div class="card-body">
            <span class="tracker-text" v-text="tracker.text"></span>
            <br />
            <template v-if="tracker.image_url">
                <v-img :src="tracker.image_url" class="pt-3" />
            </template>
        </div>
        <div class="card-footer py-1 submission-footer text-muted">
            <div class="d-flex justify-content-between flex-row">
                <small class="p-1">
                    Submitted: <nobr>{{ submissionTimeHumanReadable }}</nobr>
                </small>
                <small class="p-1 text-right">
                    <a :href="tracker.link" style="color: #5696DE; font-weight: bold; font-size: 125%;">GO TO TRACKER</a>
                </small>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'SubmissionTrackersListItemContent',

  props: {
    tracker: Object,
  },

  computed: {
    submissionTimeHumanReadable: function() {
        return this.humanReadableTime(this.timeDiff(this.tracker.submission_time));
    },
  },

  mounted() {
      this.tracker.link = this.tracker.link.replace('&amp;','&');
  },

  methods: {
    timeDiff: function(datestamp) {
        let localDateTime = new Date(datestamp + "Z");
        return Math.floor((localDateTime - Date.now()) / 1000);
    },
    humanReadableTime: function(seconds) {
        let times = {           // Seconds in:
            "years": 31536000,  // a year
            "months": 2628000,  // a month
            "weeks": 604800,    // a week
            "days": 86400,      // a day
            "hours": 3600,      // an hour
            "minutes": 60,      // a minute
        }
        let future = seconds >= 0;
        seconds = Math.abs(seconds);
        for (let time in times) {
            let interval = Math.floor(seconds/times[time]);
            if (interval >= 1) {
                if (interval === 1) {
                    time = time.slice(0, -1);
                }
                return `${interval} ${time} ${future ? 'from now' : 'ago'}`;
            }
        }
        return `${Math.floor(seconds)} seconds ${future ? 'from now' : 'ago'}`;
    },
  },
};
</script>
<style scoped>
.tracker-text {
    white-space: pre-line;
}
</style>